import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { UserResponse } from 'src/app/models/auth.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserRole } from '../../constants/keys.constant';
import { CommonService } from 'src/app/services/common.service';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';

@Component({
  selector: 'mindbase-counselling-common',
  standalone: true,
  imports: [TranslateModule, IconComponent],
  templateUrl: './counselling-common.component.html',
  styleUrl: './counselling-common.component.scss'
})
export class CounsellingCommonComponent implements OnDestroy {
  /** Visual presentation only — 'default' (unchanged) or 'stacked' (title/subtitle, full-width illustration, full-width CTA). */
  @Input() variant: 'default' | 'stacked' = 'default';

  protected subscriptionSubject$!: Subscription;
  protected profile: UserResponse | null = null;
  protected isSpecialTenant: boolean = false;
  private destroy: Subject<boolean> = new Subject<boolean>();
  constructor(
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService
  ) {
    this.getSetting();
    this.subscriptionSubject$ = this.authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null) {
          this.profile = res;         
        }
      });
  }

  getSetting(): void {
    this.commonService.settingsSubject.subscribe((res: any) => {
      if (res) {
        this.isSpecialTenant = res.isSpecialTanent;
      }
    });
  }

  navigate(type: boolean): void {
    if (type) {
      if (this.profile?.role === UserRole.TUTOR || this.profile?.role === UserRole.COUNSELOR) {
        this.router.navigate(['/tutor/support']);
      } else {
        this.router.navigate(['/support']);
      } 
    } else {
      if (this.profile?.role === UserRole.TUTOR || this.profile?.role === UserRole.COUNSELOR) {
        this.router.navigate(['/tutor/action-plan/learning-resource/articles']);
      } else {
        this.router.navigate(['/action-plan/learning-resource/articles']);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
